/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { SyncClient as _syncClient } from "@repo/sync-utils";
import {
  GetCurrentLoginInformationsOutput,
  ListResultDtoOfFlatPermissionWithLevelDto,
  UserLoginInfoDto,
} from "../../../../packages/sync-utils/src/sync/api";
import { UserAssignedApp } from "@repo/sync-utils";
import { getCookie } from "cookies-next";
import { SYNC_CONSTS } from "src/config";
import { safeParseJSON } from "./utils";
import { TeamType } from "./teams/props";
import { createClientCache } from "src/lib/api/browser-client-cache";

export const syncSessionKeys = {
  user: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skUserSufix}`,
  userPermission: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skUserPermissionSufix}`,
  userApps: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skUserAppsSufix}`,
  grantedPermissions: `${SYNC_CONSTS.appUniqueName.sync}${SYNC_CONSTS.skGrantedPermissionsSufix}`,
};

const tokenName = SYNC_CONSTS.appUniqueName.sync + SYNC_CONSTS.authTokenSufix;
const teamsInfo = SYNC_CONSTS.appUniqueName.sync + SYNC_CONSTS.teamsInfoSufix;
const currentTeam =
  SYNC_CONSTS.appUniqueName.sync + SYNC_CONSTS.currentTeamSufix;

export type SyncClient = InstanceType<typeof _syncClient>;
const browserClientCache = createClientCache<SyncClient>();

export const useClientSync = (skipAuthTokenCheck?: boolean) => {
  const authToken: string | undefined = getCookie(tokenName)?.toString() as any;
  const currentTeamFromCookie = getCookie(currentTeam)?.toString();
  const parsedCurrentTeam = safeParseJSON<TeamType>(currentTeamFromCookie);
  const currentTeamId = parsedCurrentTeam?.value;

  const createClient = () => {
    if (skipAuthTokenCheck) {
      return new _syncClient({
        BASE: SYNC_CONSTS.apiBaseAddress,
        TOKEN: authToken,
        HEADERS: { teamid: currentTeamId ?? "" },
      });
    }

    return new _syncClient({
      BASE: SYNC_CONSTS.apiBaseAddress,
      TOKEN: authToken ?? "",
      HEADERS: { teamId: currentTeamId ?? "" },
    });
  };

  if (typeof window === "undefined") {
    return createClient();
  }

  const cacheKey = JSON.stringify([
    authToken ?? "",
    currentTeamId ?? "",
    Boolean(skipAuthTokenCheck),
  ]);

  return browserClientCache.get(cacheKey, createClient);
};

export const useSyncSession = () => {
  if (typeof localStorage == "undefined") {
    return {
      user: null,
      permissions: [],
      apps: [],
      grantedPermissions: [],
    };
  }
  const userParsed = safeParseJSON<UserLoginInfoDto>(
    localStorage.getItem(syncSessionKeys.user),
  );
  const userPermissionParsed =
    safeParseJSON<ListResultDtoOfFlatPermissionWithLevelDto>(
      localStorage.getItem(syncSessionKeys.userPermission),
    );
  const grantedPermissions = safeParseJSON<string[]>(
    localStorage.getItem(syncSessionKeys.grantedPermissions),
  );
  const userLinkedApps = safeParseJSON<UserAssignedApp[]>(
    localStorage.getItem(syncSessionKeys.userApps),
  );

  const result: GetCurrentLoginInformationsOutput = {
    user: userParsed as UserLoginInfoDto,
    permissions:
      userPermissionParsed as ListResultDtoOfFlatPermissionWithLevelDto,
    apps: userLinkedApps as UserAssignedApp[],
    grantedPermissions: grantedPermissions as string[],
  };

  return result;
};
